import script from "./ClientMainLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientMainLayout.vue?vue&type=script&setup=true&lang=js"

import "./ClientMainLayout.vue?vue&type=style&index=0&id=108e226f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-108e226f"]])

export default __exports__